module.exports = __webpack_public_path__ + "media/Experiment-α・β.0a67ea51.mp3";